import { InjectionToken, Type } from '@angular/core';
import { Observable } from 'rxjs';

export enum ModalClosedReason {
    CANCELLED = 'CANCELLED',
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED',
    LOADER = 'LOADER',
    SELECTED = 'SELECTED',
    BACK = 'BACK'
}

export enum ModalSize {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE'
}

export class ModalContent<OptionsT> {
    public close: (reason: ModalClosedReason, data?: any) => boolean;
    public modalOptions: ModalOptions<OptionsT>;
    public cancel = (data?: any) => this.close(ModalClosedReason.CANCELLED, data);
    public decline = (data?: any) => this.close(ModalClosedReason.DECLINED, data);
    public accept = (data?: any) => this.close(ModalClosedReason.ACCEPTED, data);

    public setArguments(close: (reason: ModalClosedReason, data?: any) => boolean, modalOptions: ModalOptions<OptionsT>): void {
        this.close = close;
        this.modalOptions = modalOptions;
    }
}

export class ModalOptions<OptionsT> {
    title = '';
    cancelable = true;
    isSubModal = false;
    fullscreen = false;
    showHeader = true;
    classIdentifier: string;
    size: ModalSize;
    customFocus: boolean;
    footerTemplate?: Type<ModalContent<OptionsT>>;

    // contains the element IDs of the elements that contain extended information about an object
    ariaDescribedby = '';
    ariaLabel = '';

    constructor(public options?: OptionsT) {}
}

export interface ModalContainer {
    afterClosed(): Observable<ModalClosedResult>;

    close(reason: ModalClosedReason, data?: any): void;
}

export class ModalClosedResult<D = any> {
    constructor(
        public reason: ModalClosedReason,
        public data?: D
    ) {}
}

// Injection token for controlling the modal header externally, with the mobile header for example
export const AP_MODAL_HEADER_EXTERNAL_CONTROL = new InjectionToken<boolean>('AP_MODAL_HEADER_EXTERNAL_CONTROL', {
    providedIn: 'root',
    factory: () => false
});
